import { API } from "services/api";
import { CreateFedexPickupDTO } from "./fedex.types";

const FEDEX_ACCOUNT = process.env.REACT_APP_FEDEX_ACCOUNT_NUMBER;

export const postFedexPickup = async (
  payload: Omit<CreateFedexPickupDTO, "associatedAccountNumber">,
) => {
  if (!FEDEX_ACCOUNT) {
    throw new Error("FEDEX account number is not configured.");
  }

  const body: CreateFedexPickupDTO = {
    ...payload,
    associatedAccountNumber: {
      value: FEDEX_ACCOUNT,
    },
  };

  const response = await API.post("/api/fedex/pickup", body);

  return response.data;
};
